import { Link, useLocation } from 'react-router-dom';
import { ArrowLeft, Compass } from 'lucide-react';

/**
 * Phase 16 Hot-Fix — echte 404-Page anstelle des bisherigen
 * `<Route path="*" element={<Home />} />`. Dadurch sieht der User sofort,
 * wenn ein Pfad nicht zum erwarteten Component routet (Diagnose-Hilfe);
 * vorher wurde auf der Marketing-Page gelandet, was Cache- und Deploy-
 * Probleme verschleiert hat.
 */
export default function NotFound() {
  const location = useLocation();
  return (
    <main className="flex min-h-screen items-center justify-center bg-bg-primary px-4 text-fg-primary">
      <div className="w-full max-w-md rounded-xl border border-border-strong bg-bg-secondary p-8 text-center shadow-2xl">
        <span className="mb-4 inline-flex h-14 w-14 items-center justify-center rounded-full bg-accent-emergency/15 text-accent-emergency">
          <Compass className="h-7 w-7" aria-hidden />
        </span>
        <h1 className="font-display text-3xl font-bold">Seite nicht gefunden</h1>
        <p className="mt-2 text-sm text-fg-muted">
          Der Pfad{' '}
          <code className="rounded bg-bg-elevated px-1.5 py-0.5 font-mono text-xs text-fg-primary">
            {location.pathname}
          </code>{' '}
          existiert in dieser Version von Dispatch24 nicht.
        </p>
        <Link
          to="/"
          className="mt-6 inline-flex items-center gap-2 rounded-md bg-accent-emergency px-5 py-2.5 text-sm font-semibold text-white shadow-md transition hover:bg-accent-emergency-hover"
        >
          <ArrowLeft className="h-4 w-4" aria-hidden /> Zur Startseite
        </Link>
      </div>
    </main>
  );
}
